import * as actions from '../actions/actionTypes';

const initialState = {
  user: {
    hasUser: false,
    employeeName: null,
    companies: [],
  },
  loading: false,
};

const fetchUserSuccess = (state, action) => ({ ...state, user: action.user });

const fetchUserStart = state => ({ ...state, loading: true });

const fetchUserEnd = state => ({ ...state, loading: false });

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.FETCH_USER_SUCCESS:
      return fetchUserSuccess(state, action);
    case actions.FETCH_USER_START:
      return fetchUserStart(state, action);
    case actions.FETCH_USER_END:
      return fetchUserEnd(state, action);
    case actions.CLOCK_IN_OUT_SUCCESS:
      return initialState;

    default:
      return state;
  }
};

export default reducer;
